module.exports = __webpack_public_path__ + "media/images/coclick-logo-h40@2x-2339a8f0adb659aff4b1eb03e04ba212.png";